export class Constants {
    static readonly API_HOST = 'https://api.jobster.io/api/v1/';
    static readonly PAGE_HOME = '/';
    static readonly PAGE_MATCH = '/match/';
    static readonly PAGE_IMPROVE = '/improve/';
    static readonly PAGE_DASHBOARD = '/dashboard/';
    static readonly PAGE_LOGIN = '/login/';
}
